module.exports = __webpack_public_path__ + "0417aa96d0b9b04ba4b3a5c3a2378ea7.svg";